import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

export default () => (
  <Box sx={{ position: 'absolute', top: '50%', left: '50%' }}>
    <CircularProgress aria-label="Loading indicator" />
  </Box>
);
